import {fetchEndPoint,getLoginUrl} from './wordpress'

const fetchUser = async (user = "me") => {
    const userObject = await fetchEndPoint(`users/${user}`);
    userObject.isAdmin = userObject.roles.includes("administrator")
    userObject.isActiveMember = userObject.roles.includes("log_active_member")
    return userObject;
}

export const loginUrl = getLoginUrl

export default fetchUser